import { useMutation } from "@tanstack/react-query";
import { getLibraryFirstOpen, postOpenCheckLibrary } from "src/api/library";
/**
 * 자료 첫 사용 여부 확인 및 사용 로그 기록 훅
 * - checkFirstUse: 자료의 첫 사용 여부 확인 (GET /license-use-logs/{licenseId}/check-exist-log)
 * - logUsage: 자료 사용 로그 기록 (POST /license-use-logs/{licenseId})
 */ const useLibraryFirstUseCheck = ()=>{
    const { mutateAsync: checkFirstUse  } = useMutation((licenseId)=>getLibraryFirstOpen({
            licenseId
        }));
    const { mutateAsync: logUsage  } = useMutation(postOpenCheckLibrary);
    return {
        checkFirstUse,
        logUsage
    };
};
export default useLibraryFirstUseCheck;
